export const tokenPacks = [
    { name: "Starter", tokens: 250, price: 260 },
    { name: "Growth", tokens: 500, price: 450 },
    { name: "Pro", tokens: 1000, price: 800 },
  ];
  